import { Action, ActionReducer } from '@ngrx/store';

/**
 * Merges multiple reducers into a single function.
 *
 * This allows you to compose reducers for a slice from
 * multiple partial reducer functions.
 *
 * @param reducers The reducers to combine
 * @returns A single reducer function
 */
export function mergeReducers<State>(
  ...reducers: ActionReducer<State, Action>[]
): ActionReducer<State, Action> {
  const mergedReducers = (state: State | undefined, action: Action): State => {
    if (reducers.length === 0) {
      throw new Error('At least one reducer was expected');
    }
    const newState = reducers.reduce((initialState, reducer) => {
      const intermediaryState = reducer(initialState, action);
      return intermediaryState;
    }, state);

    return newState as State;
  };
  return mergedReducers;
}
